<template>
    <div v-if="recording" class="recording-transcript">
        <div v-if="summaryText || transcriptionText" class="transcript-card">
            <div class="transcript-card-header">
                <v-icon small color="success">mdi-script-text-outline</v-icon>
                Call Transcript
            </div>
            <div v-if="summaryText" class="transcript-section">
                <div class="transcript-section-label">Summary</div>
                <div
                    class="transcript-section-text"
                    dir="auto"
                    v-html="transcriptHtml(summaryText)"
                ></div>
            </div>
            <div
                v-if="hasDistinctFullTranscript"
                class="transcript-section"
                :class="{ 'mt-3': !!summaryText }"
            >
                <div class="transcript-section-label">Full Transcript</div>
                <div
                    class="transcript-section-text transcript-section-text--full"
                    dir="auto"
                    v-html="transcriptHtml(transcriptionText)"
                ></div>
            </div>
        </div>
        <div v-else class="transcript-pending">
            <v-icon small color="#aeb8bf">mdi-clock-outline</v-icon>
            Transcription pending
        </div>
    </div>
</template>

<script>
export default {
    name: "RecordingTranscript",
    props: {
        recording: {
            type: String,
            default: "",
        },
        transcription: {
            type: String,
            default: "",
        },
        transcriptionSummary: {
            type: String,
            default: "",
        },
    },
    computed: {
        summaryText() {
            return this.transcriptionValue(this.transcriptionSummary);
        },
        transcriptionText() {
            return this.transcriptionValue(this.transcription);
        },
        hasDistinctFullTranscript() {
            var full = this.stripHtml(this.transcriptionText);
            var summary = this.stripHtml(this.summaryText);
            return !!full && full !== summary;
        },
    },
    methods: {
        transcriptionValue(text) {
            if (!text) return "";
            return (text + "").trim();
        },
        stripHtml(text) {
            if (!text) return "";
            return (text + "")
                .replace(/<[^>]+>/g, " ")
                .replace(/&nbsp;/gi, " ")
                .replace(/&amp;/gi, "&")
                .replace(/&lt;/gi, "<")
                .replace(/&gt;/gi, ">")
                .replace(/&quot;/gi, '"')
                .replace(/&#39;/g, "'")
                .replace(/\s+/g, " ")
                .trim();
        },
        escapeHtml(text) {
            return (text + "")
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");
        },
        transcriptHtml(text) {
            if (!text) return "";
            if (/<[a-z][\s\S]*>/i.test(text)) {
                return text;
            }
            return this.escapeHtml(text).replace(/\r\n|\r|\n/g, "<br>");
        },
    },
};
</script>
<style>
.recording-transcript {
    margin-top: 16px;
}

.transcript-card {
    background: #f6fbf6;
    border: 1px solid #d7ecd8;
    border-left: 3px solid #4caf50;
    border-radius: 6px;
    padding: 10px 12px 12px;
}

.transcript-card-header {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #388e3c;
    margin-bottom: 8px;
}

.transcript-section-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #78909c;
    margin-bottom: 4px;
}

.transcript-section-text {
    font-size: 14px;
    line-height: 1.5;
    color: #263238;
    word-break: break-word;
    background: #fff;
    border-radius: 6px;
    padding: 8px 10px;
    border: 1px solid #e3ecee;
}

.transcript-section-text--full {
    max-height: 260px;
    overflow-y: auto;
}

.transcript-section-text p,
.transcript-section-text ul,
.transcript-section-text ol {
    margin: 0 0 0.55em;
}

.transcript-section-text p:last-child,
.transcript-section-text ul:last-child,
.transcript-section-text ol:last-child {
    margin-bottom: 0;
}

.transcript-pending {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #90a4ae;
}
</style>
